import { createClient } from "@supabase/supabase-js";
import { sharedAuthStorage } from "@/lib/cookieStorage";

const url = process.env.REACT_APP_SUPABASE_URL;
const anonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

export const supabase = createClient(url, anonKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
    // Shared storage key + apex-domain cookie => one session across both Upland apps (SSO).
    storageKey: "sb-upland-auth",
    ...(sharedAuthStorage ? { storage: sharedAuthStorage } : {}),
  },
});
